import React, { memo } from 'react'
import SharePopup from '../../../share/sharePopup'

const Share = ({ children }) => {
  return <SharePopup>{children}</SharePopup>
}

export default memo(Share)
